import "core-js/modules/web.timers.js";
import { tryOnScopeDispose } from '~/utils/VueUseHelpers';
function useTimeoutFn(interval) {
  var isPending = ref(false);
  var timer = null;
  function clear() {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
  }
  function stop() {
    isPending.value = false;
    clear();
  }
  function start() {
    clear();
    isPending.value = true;
    timer = setTimeout(function () {
      isPending.value = false;
      timer = null;
    }, interval);
  }
  tryOnScopeDispose(stop);
  return {
    isPending: isPending,
    start: start,
    stop: stop
  };
}
export function useTimeout() {
  var interval = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1e3;
  var _useTimeoutFn = useTimeoutFn(interval),
    isPending = _useTimeoutFn.isPending,
    start = _useTimeoutFn.start,
    stop = _useTimeoutFn.stop;
  var ready = computed(function () {
    return !isPending.value;
  });
  return {
    ready: ready,
    start: start,
    stop: stop
  };
}